<template>
  <div class="picmanagetable">
    <el-table :data="tableData"
              style="width: 100%;white-space:nowrap;"
              
              border
              class="tableClass">
      <el-table-column prop="createAtMY"
                       label="申请日期"
                       width="120">
        <template slot-scope="scope">
          <span>{{scope.row.createAtMY ? scope.row.createAtMY : '暂无'}}</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true"
                       prop="realName"
                       width="120px"
                       label="真实姓名">
        <template slot-scope="scope">
          <!-- :content="'昵称：'+ userInfo.name + '<br>' + '手机号：' + userInfo.mobile + '<br>' + '邮箱：' + userInfo.email" -->
          <el-popover
            placement="right"
            title="基本信息"
            width="200"
            trigger="click">
            <p class="tipck">昵称：{{userInfo.name}}</p>
            <p class="tipck">手机号：{{userInfo.mobile}}</p>
            <p class="tipck">邮箱：{{userInfo.email}}</p>
            <!-- <div slot="content">
              <span>昵称：{{userInfo.name}}</span>
              <span>手机号：{{userInfo.mobile}}</span>
              <span>邮箱：{{userInfo.email}}</span>
            </div> -->
            <span @click="seeInfoClick(scope)" style="color:#185ED3;cursor: pointer;" slot="reference">{{scope.row.realName ? scope.row.realName : '暂无'}}</span>
          </el-popover>
          
        </template>
      </el-table-column>
      <el-table-column prop="idCard"
                       label="身份证号码"
                       width="180px">
        <template slot-scope="scope">
          <span>{{scope.row.idCard ? scope.row.idCard : '暂无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address"
                       label="邮寄地址"
                       :show-overflow-tooltip="true"
                       width="200px">
        <template slot-scope="scope">
          <span>{{scope.row.address ? scope.row.address : '暂无'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="addressCode"
                       label="邮编"
                       width="100px">
        <template slot-scope="scope">
          <span>{{scope.row.addressCode ? scope.row.addressCode : '暂无'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="weixin"
                       label="微信号"
                       :show-overflow-tooltip="true"
                       width="120px">
        <template slot-scope="scope">
          <span>{{scope.row.weixin ? scope.row.weixin : '暂无'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="alipay"
                       :show-overflow-tooltip="true"
                       label="支付宝账号"
                       width="120px">
        <template slot-scope="scope">
          <span>{{scope.row.alipay ? scope.row.alipay : '暂无'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="sex"
                       label="性别"
                       width="60px">
        <template slot-scope="scope">
          <span v-if="scope.row.sex === 1">女</span>
          <span v-if="scope.row.sex === 0">男</span>
        </template>
      </el-table-column>

      <el-table-column prop="company"
                       label="单位/公司"
                       :show-overflow-tooltip="true"
                       width="200px">
        <template slot-scope="scope">
          <span>{{scope.row.company ? scope.row.company : '暂无'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="department"
                       label="部门"
                       :show-overflow-tooltip="true"
                       width="120px">
        <template slot-scope="scope">
          <span>{{scope.row.department ? scope.row.department : '暂无'}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="region"
                       label="地址"
                       :show-overflow-tooltip="true"
                       width="200px">
        <template slot-scope="scope">
          <span>{{scope.row.region ? scope.row.region : '暂无'}}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'开启'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0"> 
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="操作"
                       v-if="ischeckStatus"
                       fixed="right"
                       width="260">
        <template slot-scope="scope">
          <el-button @click="changeClick(scope)"
                     style="color:#47bd38;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-circle-check"></i>通过</el-button>
          <span style="margin:0 11px;"> | </span>
          <el-button @click="rufuseClick(scope)"
                     style="color:#F96900;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-circle-close"></i>拒绝</el-button>
          <span style="margin:0 11px;"> | </span>
          <el-button @click="disableClick(scope)"
                     style="color:#FF4545;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-delete"></i>禁用账号</el-button>
          <!-- <span style="margin:0 11px;" v-if="ischeckStatus"> | </span>
          <el-button @click="seeInfoClick(scope)"
                     style="color:#FF4545;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-document"></i>查看信息</el-button> -->
          <!-- <el-button @click="closeClick(scope)" v-if="scope.row.status === 1" style="color:#F96900;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-circle-close"></i>关闭</el-button>
          <el-button @click="closeClick(scope)" v-if="scope.row.status !== 1" style="color:#13aa65;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-document-checked"></i>开启</el-button> -->
          <!-- <span style="margin:0 11px;"> | </span>
          <el-button @click="removeClick(scope)" style="color:#FF4545;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-delete"></i>删除</el-button> -->
        </template>
      </el-table-column>

    </el-table>

    
    <el-dialog
        :visible.sync="dialogVisible"
        width="16%"
        :before-close="handleClose">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>基本信息</div>
      </div>
      <div>昵称：{{userInfo.name}}</div>
      <div>手机号：{{userInfo.mobile}}</div>
      <div>邮箱：{{userInfo.email}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">返 回</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getAppBaseConfig } from "@/api/config";
import { getUser } from "@/api/user";
// import { getDate,formatConversion } from "@/plugins/getdate";
export default {
  name: 'userauthtable',
  props: {
    tableData: Array,
    ischeckStatus: Boolean
  },

  data () {
    return {
      userInfo:{},
      dialogVisible:false,

      popoverLoading:false,

      isRealName: false,
      isIdCard: false,
      isAddress: false,
      isAddressCode: false,
      isWeixin: false,
      isAlipay: false,
      isCompany: false,
      isDepartment: false,
      isSex: false,
      isregion: false,
      // tableData:[
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'52个',
      //     pics:'630张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'人文图片库',
      //     picj:'5个',
      //     pics:'30张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'0个',
      //     pics:'0张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'1234个',
      //     pics:'95487张',
      //   },
      // ]
    }
  },
  methods: {
    // ...mapActions(["setDialogFormVisible"]),
    changeClick (scope) {
      this.$emit('changeClick', scope)

    },
    //删除图片库
    rufuseClick (scope) {

      this.$emit('rufuseClick', scope)

    },
    //关闭或者开始图片库
    disableClick (scope) {

      this.$emit('disableClick', scope)

    },

    handleClose(){
      this.dialogVisible = false
    },

    //查看用户信息
    seeInfoClick (scope) {
      // console.log(scope.row);
      this.getUserAsync(scope.row.uid)
      

    },

    //获取用户信息
    async getUserAsync (val) {
      let { status, data, message } = await getUser(val);
      if (status) {
        this.userInfo = data
        // this.dialogVisible = true
      }else{
        this.$message.warning('获取用户信息失败')
      }
    },

    //获取应用基础配置
    async getAppBaseConfigAsync () {
      let { status, data, message } = await getAppBaseConfig();
      if (status) {
        if (data.authenticationFields) {
          if (data.authenticationFields.indexOf('realName') !== -1) {
            this.isRealName = true
          } else {
            this.isRealName = false
          }

          if (data.authenticationFields.indexOf('idCard') !== -1) {
            this.isIdCard = true
          } else {
            this.isIdCard = false
          }

          if (data.authenticationFields.indexOf('address') !== -1) {
            this.isAddress = true
          } else {
            this.isAddress = false
          }

          if (data.authenticationFields.indexOf('addressCode') !== -1) {
            this.isAddressCode = true
          } else {
            this.isAddressCode = false
          }

          if (data.authenticationFields.indexOf('weixin') !== -1) {
            this.isWeixin = true
          } else {
            this.isWeixin = false
          }

          if (data.authenticationFields.indexOf('alipay') !== -1) {
            this.isAlipay = true
          } else {
            this.isAlipay = false
          }

          if (data.authenticationFields.indexOf('company') !== -1) {
            this.isCompany = true
          } else {
            this.isCompany = false
          }

          if (data.authenticationFields.indexOf('department') !== -1) {
            this.isDepartment = true
          } else {
            this.isDepartment = false
          }

          if (data.authenticationFields.indexOf('sex') !== -1) {
            this.isSex = true
          } else {
            this.isSex = false
          }

          if (data.authenticationFields.indexOf('region') !== -1) {
            this.isregion = true
          } else {
            this.isregion = false
          }
        }
      }
    }

  },
  created () {
    this.getAppBaseConfigAsync()
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/constants/elHeader.scss";
.tableClass ::v-deep .cell {
  white-space: nowrap;
}
.table {
  width: auto;
}
.btn:hover {
  text-decoration: underline;
}
// 滚动条的宽度
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 10px; // 纵向滚动条 必写
}
// 滚动条的滑块
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 5px;
}
::v-deep .el-table__fixed-right {
  height: 100% !important;
}
</style>
